import backend from '../../components/utils/backend'
export default {
  state: {
    tables: []
  },
  mutations: {
    'SET_TABLES': function (state, payload) {
      state.tables = payload
    }
  },
  actions: {
    getTables ({ commit, rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await backend.get('/api/v1/domain-configuration', rootGetters['session/accessToken'])
          if (response.body && response.body.httpCode && response.body.httpCode !== '200') {
            throw new Error(response.body.httpMessage)
          }

          commit('SET_TABLES', response.body)
          resolve(response.body)
        } catch (error) {
          reject(error)
        }
      })
    },
    updateTable ({ rootGetters }, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await backend.put(`/api/v1/domain-configuration/${payload.tableName}`, rootGetters['session/accessToken'], payload.body)
          if (response.body && response.body.httpCode && response.body.httpCode !== '200') {
            throw new Error(response.body.httpMessage)
          }
          resolve(response)
        } catch (error) {
          reject(error)
        }
      })
    }
  },
  namespaced: true
}
